<template>
    <div>
        <v-overlay :z-index="1000" :value="show">
            <v-dialog v-model="show" hide-overlay persistent width="500">
                <v-card color="primary" dark>
                    <v-card-text>
                        <span class="loader-text">{{text}}</span>	
                        <v-progress-linear indeterminate color="#45aea1" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-overlay>

        <slot></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState("app", ["loaderShow", "loaderText", "loaderQueue" ]),
        show(){
            if((this.loaderQueue || []).length > 0 || this.loaderShow)
                return true;
            else 
                return false;
        },
        text(){
            if(this.loaderText != null) 
                return this.loaderText; 

            return this.$t("Common.processing");
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../styles/material-dashboard/variables";

.v-application .primary {
    background-color: #25313a !important;
    border-color: #45aea1 !important;
}
.v-dialog__content {
    z-index: 1001 !important;
}
.v-dialog>.v-card>.v-card__subtitle, .v-dialog>.v-card>.v-card__text {
    padding-top: 10px;
}
.loader-text{
    color: $white-sonda !important;
    font-weight: bold;  
}
.v-progress-linear{
    margin-top: 10px;
    padding-top: 5px;
}
</style>
